// extracted by mini-css-extract-plugin
export default {"sharingConfigs":"TeamCardBadgeList_sharingConfigs__sAHQ2","title":"TeamCardBadgeList_title__IoNGu","tagList":"TeamCardBadgeList_tagList__2Nee+"};